<form [formGroup]="form">
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="content-align-left"
  >
    <div *ngIf="displayMode === 'customer'">
      <div fxLayout="column" fxFlex="65">
        <h4>There are no 3rd Party Authorization forms on file.</h4>
        <h4>Please upload a hard copy or create one electronically.</h4>
      </div>

      <div fxFlex="20">
        <button
          mat-stroked-button
          type="button"
          color="accent"
          (click)="create3Pa()"
        >
          <mat-icon>add</mat-icon> Create 3PA
        </button>
      </div>
    </div>
    <div fxLayout="column" *ngIf="displayMode === 'admin'">
      <h4>3rd Party Authorization</h4>
    </div>

    <digital-platform-file-upload
      fxFlex="30"
      formControlName="thirdPartyAuthAttachment"
      (fileDeleted)="onFileDelete($event)"
    ></digital-platform-file-upload>
  </div>
</form>
<br />
<h4 *ngIf="displayMode === 'customer'" class="content-align-left">
  Note: Profile will be put into "Pending" status while creating a 3PA until it
  has been approved.
</h4>
